import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import Camera from '@elem/SVGIcon/OutdoorRecreation/Camera';
import Fan from '@elem/SVGIcon/OutdoorRecreation/Fan';
import Display from '@elem/SVGIcon/PowerBackup/Display';
import ElectricBlanket from '@elem/SVGIcon/PowerBackup/ElectricBlanket';
import Laptop from '@elem/SVGIcon/PowerBackup/Laptop';
import MiniFridge from '@elem/SVGIcon/PowerBackup/MiniFridge';
import Refrigerator from '@elem/SVGIcon/PowerBackup/Refrigerator';
import WiFiRouter from '@elem/SVGIcon/PowerBackup/WiFiRouter';
import CarFridge from '@elem/SVGIcon/VanlifeRoadtrips/CarFridge';
import Projector from 'elem/SVGIcon/OutdoorRecreation/Projector';
import Light from 'elem/SVGIcon/PowerBackup/Light';
import Phone from 'elem/SVGIcon/PowerBackup/Phone';
import WaterPump from 'elem/SVGIcon/VanlifeRoadtrips/WaterPump';
// import EFPicture from 'elem/compCommon/EFPicture';
import EcoImg from 'eco-design/base/eco-img';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';

export default function E() {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    const [open, setOpen] = useState(false);
    // 欧规站点
    const EU_SITES: string[] = ['eu', 'de', 'fr', 'it', 'es', 'cis', 'kr'];
    // ZA 南非规格
    const ZA_SITE: string[] = ['za'];
    // 本地化规格
    const LOCAL_SITES: string[] = ['za', 'uk', 'au'];
    const isUSOrCA = ['us', 'ca'].includes(locale);

    let cards: any = [
        {
            img: ['us', 'ca'].includes(locale)
                ? ''
                : `/responsive/picture/common-products/river${ZA_SITE.includes(locale) ? '' : '2'}pro${
                      EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES.includes(locale) ? `_${locale}` : ''
                  }.png`,
            power: t('secE_card1_power'),
            title: t('secE_card1_title'),
            tag: ['au'].includes(locale) ? t('common_card_tag_best_seller') : '',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/river-2-pro-portable-power-station?_pos=1&_sid=355fb124b&_ss=r&variant=40563653378121',
                    ca: 'https://ca.ecoflow.com/products/river-2-pro-portable-power-station?variant=52471099490675',
                    de: 'https://de.ecoflow.com/products/river-2-pro-portable-power-station',
                    za: 'https://za.ecoflow.com/products/river-pro-portable-power-station',
                    fr: 'https://fr.ecoflow.com/products/river-2-pro-portable-power-station',
                    eu: 'https://eu.ecoflow.com/products/river-2-pro-portable-power-station',
                    uk: 'https://uk.ecoflow.com/products/river-2-pro-portable-power-station',
                    it: 'https://it.ecoflow.com/products/river-2-pro-portable-power-station',
                    es: 'https://es.ecoflow.com/products/river-2-pro-portable-power-station',
                    au: 'https://au.ecoflow.com/products/river-2-pro-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/river-2-pro-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6859087282249',
                    ca: '7539942064282',
                    de: '7815351075063',
                    za: '7027757121745',
                    fr: '7929781977314',
                    eu: '7472877699236',
                    uk: '7388078407872',
                    it: '7842358984945',
                    es: '7850943152350',
                    au: '7756526584006',
                    kr: '7743151833257',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40563653378121',
                    ca: '52471099490675',
                    de: '46769125687631',
                    za: '41601862926545',
                    fr: '46833280024923',
                    eu: '46822242713943',
                    uk: '46728982724947',
                    it: '47043066823005',
                    es: '46831957934427',
                    au: '42673598824646',
                    kr: '43056132882601',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secE_card1_desc1'), t('secE_card1_desc2'), t('secE_card1_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secE_card1_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secE_card1_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon2_desc'),
                },
                {
                    icon: isUSOrCA ? (
                        <WiFiRouter className="card-icon" />
                    ) : ZA_SITE.includes(locale) ? (
                        <Fan className="card-icon" />
                    ) : (
                        <WaterPump className="card-icon" />
                    ),
                    title: t.rich('secE_card1_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon3_desc'),
                },
                {
                    icon: isUSOrCA ? (
                        <Laptop className="card-icon" />
                    ) : ZA_SITE.includes(locale) ? (
                        <Camera className="card-icon" />
                    ) : (
                        <Fan className="card-icon" />
                    ),
                    title: t.rich('secE_card1_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon4_desc'),
                },
                {
                    icon: isUSOrCA ? <Refrigerator className="card-icon" /> : <CarFridge className="card-icon" />,
                    title: t.rich('secE_card1_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon5_desc'),
                },
                {
                    icon: isUSOrCA ? <ElectricBlanket className="card-icon" /> : <Projector className="card-icon" />,
                    title: t.rich('secE_card1_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon6_desc'),
                },
            ],
        },
        {
            img: isUSOrCA
                ? ''
                : `/responsive/picture/common-products/river2max${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.png`,
            power: t('secE_card2_power'),
            title: t('secE_card2_title'),
            tag: ZA_SITE.includes(locale) ? t('common_card_tag_new_arrival') : '',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/river-3-plus-portable-power-station?variant=41636515807305',
                    ca: 'https://ca.ecoflow.com/products/river-3-plus-portable-power-station?variant=52355124134259',
                    de: 'https://de.ecoflow.com/products/river-2-max-portable-power-station',
                    za: 'https://za.ecoflow.com/products/river-2-max-portable-power-station',
                    fr: 'https://fr.ecoflow.com/products/river-2-max-portable-power-station',
                    eu: 'https://eu.ecoflow.com/products/river-2-max-portable-power-station',
                    uk: 'https://uk.ecoflow.com/products/river-2-max-portable-power-station',
                    it: 'https://it.ecoflow.com/products/river-2-max-portable-power-station',
                    es: 'https://es.ecoflow.com/products/river-2-max-portable-power-station',
                    au: 'https://au.ecoflow.com/products/river-2-max-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/river-2-max-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7290968473673',
                    ca: '15039583682931',
                    de: '7815349371127',
                    za: '7187058753745',
                    fr: '7928802607330',
                    eu: '7472877338788',
                    uk: '7388078670016',
                    it: '7841513242865',
                    es: '7850071392478',
                    au: '7756526026950',
                    kr: '7743151800489',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41636515807305',
                    ca: '52355124134259',
                    de: '46769179066703',
                    za: '41462253813969',
                    fr: '46833261445467',
                    eu: '46822249365847',
                    uk: '46729106719059',
                    it: '47043065250141',
                    es: '46831955542363',
                    au: '42649690210502',
                    kr: '43056131276969',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secE_card2_desc1'), t('secE_card2_desc2'), t('secE_card2_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secE_card2_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secE_card2_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon2_desc'),
                },
                {
                    icon: isUSOrCA ? (
                        <WiFiRouter className="card-icon" />
                    ) : ZA_SITE.includes(locale) ? (
                        <Fan className="card-icon" />
                    ) : (
                        <WaterPump className="card-icon" />
                    ),
                    title: t.rich('secE_card2_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon3_desc'),
                },
                {
                    icon: isUSOrCA ? (
                        <Laptop className="card-icon" />
                    ) : ZA_SITE.includes(locale) ? (
                        <Camera className="card-icon" />
                    ) : (
                        <Fan className="card-icon" />
                    ),
                    title: t.rich('secE_card2_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon4_desc'),
                },
                {
                    icon: isUSOrCA ? <Display className="card-icon" /> : <CarFridge className="card-icon" />,
                    title: t.rich('secE_card2_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon5_desc'),
                },
                {
                    icon: isUSOrCA ? <MiniFridge className="card-icon" /> : <Projector className="card-icon" />,
                    title: t.rich('secE_card2_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon6_desc'),
                },
            ],
        },
        {
            img: isUSOrCA
                ? ''
                : `/responsive/picture/common-products/river2${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.png`,
            power: t('secE_card3_power'),
            title: t('secE_card3_title'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/river-3-plus-portable-power-station?variant=41636514136137',
                    ca: 'https://ca.ecoflow.com/products/river-3-plus-portable-power-station?variant=52355185279347',
                    de: 'https://de.ecoflow.com/products/river-2-portable-power-station',
                    za: 'https://za.ecoflow.com/products/river-2-portable-power-station',
                    fr: 'https://fr.ecoflow.com/products/river-2-portable-power-station',
                    eu: 'https://eu.ecoflow.com/products/river-2-portable-power-station',
                    uk: 'https://uk.ecoflow.com/products/river-2-portable-power-station',
                    it: 'https://it.ecoflow.com/products/river-2-portable-power-station',
                    es: 'https://es.ecoflow.com/products/river-2-portable-power-station',
                    au: 'https://au.ecoflow.com/products/river-2-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/river-2-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7290968473673',
                    ca: '15039583682931',
                    de: '7805118578935',
                    za: '7187058000081',
                    fr: '7912640086242',
                    eu: '7460419141796',
                    uk: '7372420874432',
                    it: '7830533341425',
                    es: '7830737158366',
                    au: '7756518654150',
                    kr: '7675398324393',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41636514136137',
                    ca: '52355185279347',
                    de: '46799171420495',
                    za: '41462251815121',
                    fr: '46833231429979',
                    eu: '46822257951063',
                    uk: '46729122480467',
                    it: '47043061350749',
                    es: '46831951479131',
                    au: '42649688244422',
                    kr: '42818404286633',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secE_card3_desc1'), t('secE_card3_desc2'), t('secE_card3_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secE_card3_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secE_card3_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon2_desc'),
                },
                {
                    icon: isUSOrCA ? (
                        <WiFiRouter className="card-icon" />
                    ) : ZA_SITE.includes(locale) ? (
                        <Fan className="card-icon" />
                    ) : (
                        <WaterPump className="card-icon" />
                    ),
                    title: t.rich('secE_card3_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon3_desc'),
                },
                {
                    icon: isUSOrCA ? (
                        <Laptop className="card-icon" />
                    ) : ZA_SITE.includes(locale) ? (
                        <Camera className="card-icon" />
                    ) : (
                        <Fan className="card-icon" />
                    ),
                    title: t.rich('secE_card3_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon4_desc'),
                },
                {
                    icon: isUSOrCA ? <Display className="card-icon" /> : <CarFridge className="card-icon" />,
                    title: t.rich('secE_card3_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon5_desc'),
                },
                {
                    icon: isUSOrCA ? <MiniFridge className="card-icon" /> : <Projector className="card-icon" />,
                    title: t.rich('secE_card3_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon6_desc'),
                },
            ],
        },
    ];

    if (locale === 'au') {
        cards.reverse();
    }
    if (isUSOrCA) {
        cards = [
            {
                img: '',
                power: t('secE_card4_power'),
                title: t('secE_card4_title'),
                id: 'T200',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/trail-series?variant=54553979682889',
                        ca: 'https://ca.ecoflow.com/products/trail-series?variant=52734893490547',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '15350808346697',
                        ca: '15127284351347',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '54553979682889',
                        ca: '52734893490547',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [t('secE_card4_desc1'), t('secE_card4_desc2'), t('secE_card4_desc3')],
                iconArr: [
                    {
                        icon: <Light className="card-icon" />,
                        title: t.rich('secE_card4_icon1_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card4_icon1_desc'),
                    },
                    {
                        icon: <Phone className="card-icon" />,
                        title: t.rich('secE_card4_icon2_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card4_icon2_desc'),
                    },
                    {
                        icon: <Camera className="card-icon" />,
                        title: t.rich('secE_card4_icon3_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card4_icon3_desc'),
                    },
                    {
                        icon: <Fan className="card-icon" />,
                        title: t.rich('secE_card4_icon4_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card4_icon4_desc'),
                    },
                    {
                        icon: <Projector className="card-icon" />,
                        title: t.rich('secE_card4_icon5_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card4_icon5_desc'),
                    },
                    {
                        icon: <Refrigerator className="card-icon" />,
                        title: t.rich('secE_card4_icon6_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card4_icon6_desc'),
                    },
                ],
            },

            {
                img: '',
                power: t('secE_card5_power'),
                title: t('secE_card5_title'),
                id: 'T300',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/trail-series?variant=54553980043337',
                        ca: 'https://ca.ecoflow.com/products/trail-series?variant=52734893523315',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '15350808346697',
                        ca: '15127284351347',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '54553980043337',
                        ca: '52734893523315',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [t('secE_card5_desc1'), t('secE_card5_desc2'), t('secE_card5_desc3')],
                iconArr: [
                    {
                        icon: <Light className="card-icon" />,
                        title: t.rich('secE_card5_icon1_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card5_icon1_desc'),
                    },
                    {
                        icon: <Phone className="card-icon" />,
                        title: t.rich('secE_card5_icon2_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card5_icon2_desc'),
                    },
                    {
                        icon: <Camera className="card-icon" />,
                        title: t.rich('secE_card5_icon3_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card5_icon3_desc'),
                    },
                    {
                        icon: <Fan className="card-icon" />,
                        title: t.rich('secE_card5_icon4_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card5_icon4_desc'),
                    },
                    {
                        icon: <Projector className="card-icon" />,
                        title: t.rich('secE_card5_icon5_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card5_icon5_desc'),
                    },
                    {
                        icon: <Refrigerator className="card-icon" />,
                        title: t.rich('secE_card5_icon6_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secE_card5_icon6_desc'),
                    },
                ],
            },
            ...cards,
        ];
    }

    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        try {
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            const { price, compareAtPrice, inventoryPolicy, inventoryQuantity, productId, variantId, variantImg, img, productTitle, skuTitle } = card;
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
                {
                    price,
                    compareAtPrice,
                    inventoryPolicy,
                    inventoryQuantity,
                    productId,
                    variantId,
                    variantImg,
                    img,
                    productTitle,
                    skuTitle,
                    quantity: 1,
                } as ItfEcoCartItem,
            ]);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
        }
    }, []);

    useEffect(() => {
        const tempArr = [...cards];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (res?.data?.handle) {
                            tempArr[k].link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                        }
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                        return resolve({ ...tempArr?.[k], ...res?.data });
                    } else {
                        console.error(res?.message);
                        return reject({ ...tempArr?.[k] });
                    }
                } catch (e) {
                    console.error(e);
                    return reject({ ...tempArr?.[k] });
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then((res: any) => {
                setCardLists(res);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="vanlife-roadtrips-E" className={`vanlife-roadtrips-E ${css['vanlife-roadtrips-E']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secE_title')}</p>
                </div>
                <Swiper
                    className="cards swiper-box"
                    effect="fade"
                    modules={[Scrollbar]}
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {cardLists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            {card?.tag && <span className="card-tag">{card?.tag}</span>}
                            <EcoImg className="ef-picture" pc={card.variantImg || card?.img} />
                            <div className="box-1">
                                <div className="box-2">
                                    <p className="card-power">{card?.power}</p>
                                    <p className="card-title">{card?.title || card?.productTitle || card?.skuTitle}</p>
                                    <ul className="card-descs">
                                        {card?.descArr?.map((desc: any, m: number) => (
                                            <li className="card-desc" key={`${k}_${m}`}>
                                                {desc}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="box-3">
                                    <ul className={`card-icons${open ? ' open' : ''}`}>
                                        {card?.iconArr?.map((icon: any, n: number) => (
                                            <li className="card-icon-item" key={`${k}_${n}`}>
                                                {icon?.icon}
                                                <p className="icon-title">{icon?.title}</p>
                                                <p className="icon-desc">{icon?.desc}</p>
                                            </li>
                                        ))}
                                    </ul>
                                    {!open && (
                                        <span className="card-arrow" onClick={() => setOpen(true)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                                                <path d="M1.5 1L4.5 4L7.5 1" stroke="#AEAEAE" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    )}

                                    <div className="card-btns">
                                        {card?.link_buy && (
                                            <>
                                                {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? (
                                                    <button disabled className={`btn-buy card-btn disable`}>
                                                        {t('common_card_out')}
                                                    </button>
                                                ) : (
                                                    <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                        {t('common_card_buy')}
                                                    </p>
                                                )}
                                            </>
                                        )}
                                        {card?.link_more && (
                                            <Link
                                                className="btn-more card-btn"
                                                href={`${card?.link_more}${
                                                    String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                                }utm_source=scenario+page&utm_medium=Pillar`}
                                                target="_blank"
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'select_product',
                                                    list_name: t('secE_title'),
                                                    product_name: card.title,
                                                    button_name: t('common_card_more'),
                                                }}
                                            >
                                                {t('common_card_more')}
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
